<template lang="pug">
server-data.h-100(
  ref="list"
  :method="method"
  v-slot="{ serverData, search, init, loading, pagination }"
)
  v-card.sdo-card.px-2(
    :loading="loading"
    height="100%"
  )
    .sticky
      v-sheet.py-2.d-flex.align-center
        v-text-field(
          v-model="searchKeys.number"
          label="Номер договора"
          :loading="loading"
          rounded filled hide-details
        )
          //- template(#prepend)
          //-   v-menu(
          //-     :close-on-content-click="false"
          //-   )
          //-     template(#activator="{ on }")
          //-       v-btn(
          //-         v-on="on"
          //-         color="grey darken-2"
          //-         fab depressed small outlined
          //-       ): v-icon mdi-filter
          //-     v-sheet
          //-       v-col
          //-         component(
          //-           v-for="item in filters"
          //-           :is="item.is"
          //-         )
          template(#append-outer)
            v-btn(
              color="primary"
              depressed fab small
              @click="search"
            )
              v-icon mdi-magnify
    v-list.overflow-y-auto.scroll(
      v-if="serverData && serverData.length && !loading"
      height="100%"
    )
      v-list-item-group(
        v-model="selected"
      )
        v-list-item(
          v-for="(item, index) in serverData" :key="index"
          :value="item"
        )
          slot(name="list-item" v-bind="{ item, index }")
        //- div(v-if="serverData.length"
        //- v-intersect="onIntersect")
    v-card-actions.white(
    )
      v-pagination(
        v-if="pagination && pagination.pages   > 1"
        v-model="pagination.page"
        :length="pagination.pages"
        @input="init"
      )
      v-spacer
      ev-chip(v-if="pagination" color="primary" small :text="`${pagination.total}` || '2'")
    v-alert.ma-2(v-if="!serverData.length && !loading"  type="info") Данные отсутсвуют
</template>

<script>

export default {
  props: {
    value: { type: Object, default: () => ({}) },
    method: { type: Function, required: true },
    isMobile: { type: Boolean, default: false },
    pagination: { type: Boolean, default: true },
    filters: { type: Array, default: () => ([]) },
  },
  data() {
    return {
      noClose: false,
      page: 1,
      selected: null,
      searchKeys: {},
      extendSearchKeys: {},
    };
  },
  computed: {
    query() {
      return {
        ...this.searchKeys,
        ...this.pagination ? { page: this.page } : {},
      };
    },
  },
  watch: {
    value: {
      handler(val) {
        if (!val) this.selected = null;
      },
      immediate: true,
    },
    selected(val) {
      this.$emit('input', val);
      if (!this.noClose) this.$emit('close');
      this.noClose = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.filter {
  ::v-deep .v-list-item__title {
    white-space: normal !important;
  }
}
</style>
